export abstract class CoreService {

  handleError(errorMessage: string): boolean {
    console.log(errorMessage);
    return false;
  }
}
